module.exports = __webpack_public_path__ + "img/logo.a2789463.png";